import { useEffect, useRef } from "react";
import Quill from "quill";
import "quill/dist/quill.snow.css";
//import QuillBetterTable from "quill-table-better";
import { stdObject } from "../data/types/stdObject";

// Quill.register(
//   {
//     "modules/better-table": QuillBetterTable,
//   },
//   true,
// );

export default function TextEditor({ data }: stdObject) {
  const editorRef = useRef<HTMLDivElement>(null);
  const quillRef = useRef<Quill | null>(null);
  const onChangeRef = useRef(data.onChange);
  const lastEmittedValue = useRef<string | null>(null);

  useEffect(() => {
    onChangeRef.current = data.onChange;
  }, [data.onChange]);

  useEffect(() => {
    if (!editorRef.current) return;

    if (!quillRef.current) {
      quillRef.current = new Quill(editorRef.current, {
        theme: "snow",
        // placeholder: "Write something...",
        modules: {
          // table: false,
          toolbar: [
            [{ font: [] }],
            // [{ header: [1, 2, false] }],
            [{ size: [] }],
            [{ color: [] }, { background: [] }],
            ["bold", "italic", "underline", "strike"],
            [{ align: [] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["image", "video"],
            ["link"],
            // ["table"],
            ["clean"],
          ],
          // "better-table": {
          //   operationMenu: {
          //     items: {
          //       unmergeCells: {
          //         text: "Another unmerge cells name",
          //       },
          //     },
          //   },
          // },
          // keyboard: {
          //   bindings: QuillBetterTable.keyboardBindings,
          // },
        },
      });
    }

    const quill = quillRef.current;
    const handleTextChange = () => {
      const delta = quill.root.innerHTML; //quill.getContents(); //
      if (typeof delta === "string") {
        lastEmittedValue.current = delta;
        onChangeRef.current?.(delta);
      }
    };

    quill.on("text-change", handleTextChange);

    return () => {
      quill.off("text-change", handleTextChange);
    };
  }, []);

  useEffect(() => {
    if (!quillRef.current) return;
    const nextValue = typeof data.value === "string" ? data.value : "";
    if (nextValue !== lastEmittedValue.current) {
      quillRef.current.root.innerHTML = nextValue;
      lastEmittedValue.current = nextValue;
    }
  }, [data.value]);

  const handleInsertTable = () => {
    const tableModule = quillRef.current?.getModule("better-table") as any;
    tableModule?.insertTable(3, 3);
  };

  return (
    <div className="textEditor">
      {/*<button onClick={handleInsertTable}>Insertar Tabla 3x3</button>*/}
      <div ref={editorRef} />
    </div>
  );
}
